import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Image from '../../components/Image';
import Typography from '../../components/Typography';
import Hidden from "@material-ui/core/Hidden";

const styles = theme => ({
    root: {
        width: '100%',
        textAlign: 'center',
        backgroundColor: theme.palette.secondary.dark,
        textTransform: 'uppercase',
        color: 'white',
        fontSize: '.77rem',
        letterSpacing: '.18rem',
        padding: '7px 0',
    },
    phoneLink: {
        textDecoration: 'underline',
        color: 'white',
        '&:hover': {
            color: 'white'
        }
    },
    close: {
        float: 'right',
        marginRight: 5,
        cursor: 'pointer',
        fontSize: '1rem',
        lineHeight: '1rem',
    }
});

class CallUsBanner extends React.Component {
    state = {
        display: 'block',
    }

    close = e => {
        this.setState({display: 'none'});
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root} style={{display: this.state.display}}>
                <Typography variant='subtitle2' style={{margin: 0, color: 'white'}} inline={true}>
                    <Image src="/homepage/whitephone.svg"/>
                      &nbsp; Have questions? Or Need Help?
                      <Hidden mdUp><br/></Hidden>
                      <Hidden smDown>&nbsp;</Hidden>
                      Call US&nbsp;<a href="tel:+18447686945" className={classes.phoneLink}>(844) 768-6945</a>
                </Typography>
                <div className={classes.close} onClick={this.close}>&times;</div>
            </div>
        );
    }
}

CallUsBanner.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CallUsBanner);
